import React, { FunctionComponent } from 'react';
import './Spinner.css';

export const Spinner: FunctionComponent = () => <div id='cover-spin' />;
